module.exports = __webpack_public_path__ + "static/media/KI.f5740a9b.png";